// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type ServerGroupFormOptionsQueryVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
}>;

export type ServerGroupFormOptionsQuery = {
  __typename?: "GraphqlQuery";
  getServerGroups: Array<{
    __typename?: "ServerGroup";
    id: string;
    name: string;
    description?: string | null;
    memberServerIds: Array<string>;
    memberServerGroupIds: Array<string>;
    canIncludeServerGroups: boolean;
  }>;
};

export const ServerGroupFormOptionsDocument = gql`
  query ServerGroupFormOptions($organizationSlug: ID!) {
    getServerGroups(organizationSlug: $organizationSlug, custom: true) {
      id
      name
      description
      memberServerIds
      memberServerGroupIds
      canIncludeServerGroups
    }
  }
`;

/**
 * __useServerGroupFormOptionsQuery__
 *
 * To run a query within a React component, call `useServerGroupFormOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useServerGroupFormOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServerGroupFormOptionsQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *   },
 * });
 */
export function useServerGroupFormOptionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ServerGroupFormOptionsQuery,
    ServerGroupFormOptionsQueryVariables
  > &
    (
      | { variables: ServerGroupFormOptionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ServerGroupFormOptionsQuery,
    ServerGroupFormOptionsQueryVariables
  >(ServerGroupFormOptionsDocument, options);
}
export function useServerGroupFormOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ServerGroupFormOptionsQuery,
    ServerGroupFormOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ServerGroupFormOptionsQuery,
    ServerGroupFormOptionsQueryVariables
  >(ServerGroupFormOptionsDocument, options);
}
// @ts-ignore
export function useServerGroupFormOptionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ServerGroupFormOptionsQuery,
    ServerGroupFormOptionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ServerGroupFormOptionsQuery,
  ServerGroupFormOptionsQueryVariables
>;
export function useServerGroupFormOptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServerGroupFormOptionsQuery,
        ServerGroupFormOptionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ServerGroupFormOptionsQuery | undefined,
  ServerGroupFormOptionsQueryVariables
>;
export function useServerGroupFormOptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServerGroupFormOptionsQuery,
        ServerGroupFormOptionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ServerGroupFormOptionsQuery,
    ServerGroupFormOptionsQueryVariables
  >(ServerGroupFormOptionsDocument, options);
}
export type ServerGroupFormOptionsQueryHookResult = ReturnType<
  typeof useServerGroupFormOptionsQuery
>;
export type ServerGroupFormOptionsLazyQueryHookResult = ReturnType<
  typeof useServerGroupFormOptionsLazyQuery
>;
export type ServerGroupFormOptionsSuspenseQueryHookResult = ReturnType<
  typeof useServerGroupFormOptionsSuspenseQuery
>;
export type ServerGroupFormOptionsQueryResult = Apollo.QueryResult<
  ServerGroupFormOptionsQuery,
  ServerGroupFormOptionsQueryVariables
>;
